import LongevitySubSection from './LongevitySubSection';

export default LongevitySubSection;
